
import { Vue, Component, Prop } from "vue-property-decorator";

import SolDialog from "./SolDialog.vue";

const openDelay = 1_500;
const closeDelay = 5_000;

interface AuthValue {
  user: any;
  loggedIn: boolean;
  logout(): any;
}
@Component({
  components: { SolDialog },
})
export default class SolNotification extends Vue {
  @Prop() readonly auth!: AuthValue;

  showPopup: boolean = false;
  closePopupTimer: any = null;
  // To hold the popup open when hovered
  hoverHold: boolean = false;

  mounted(): void {
    if (this.canDispatch) {
      this.$store.dispatch("fetchRecentLiveCalls", { country: this.country });
    }
    if (this.unreadCount > 0) {
      this.schedulePopup();
    }
  }

  get country(): string {
    const routeCountry =
      this.$route && this.$route.params ? this.$route.params.country : null;
    return typeof routeCountry === "string" ? routeCountry : "";
  }

  get unreadCount(): number {
    return this.recentCalls.filter((entry: any) => {
      const state = (entry?.state || "").toLowerCase();
      return (
        state !== "completed" && state !== "failed" && state !== "declined"
      );
    }).length;
  }

  get recentCalls(): any[] {
    const storeState = this.$store ? this.$store.state : null;
    return (storeState && storeState.recentLiveCalls) || [];
  }

  schedulePopup(): void {
    // Automatically show the popup after `openDelay` ms
    setTimeout(() => {
      this.openPopup();
    }, openDelay);
  }

  openPopup(): void {
    if (this.closePopupTimer) {
      clearTimeout(this.closePopupTimer);
    }
    this.showPopup = true;
    // Automatically hide the popup after `closeDelay` ms
    this.closePopupTimer = setTimeout(() => {
      this.showPopup = false;
    }, closeDelay);
  }

  closePopup(): void {
    if (this.closePopupTimer) {
      clearTimeout(this.closePopupTimer);
      this.closePopupTimer = null;
    }
    this.hoverHold = false;
    this.showPopup = false;
  }

  enterPopup(): void {
    if (this.showPopup) {
      // Hold only if the popup is already shown
      this.hoverHold = true;
    }
  }

  leavePopup(): void {
    this.hoverHold = false;
  }

  openDialog(): void {
    if (this.canDispatch) {
      this.$store.dispatch("fetchRecentLiveCalls", { country: this.country });
    }
    this.closePopup();
    if (this.$refs.solDialog) {
      (this.$refs.solDialog as InstanceType<typeof SolDialog>).show();
    }
  }

  private get canDispatch(): boolean {
    return !!this.$store && typeof (this.$store as any).dispatch === "function";
  }
}
